import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "subtitle" }, "\"Esc\" to close", -1)

export function render(_ctx, _cache) {
  const _component_search = _resolveComponent("search")
  const _component_base_modal = _resolveComponent("base-modal")

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "modal",
    onOnClose: _ctx.onModalClose
  }, {
    header: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_search, {
        data: _ctx.searchData,
        onOnItemNavigate: _ctx.close,
        ref: "search"
      }, null, 8, ["data", "onOnItemNavigate"])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}

  import BaseModal from "./BaseModal.vue"
  import Search from "./Search.vue"
  import {
    transformSearchReferenceItem,
    fetchStyleguideData,
  } from "../../helpers/search"

  /**
   * TheSearchModal component data.
   * @typedef {Object} TheSearchModalData
   * @property {SearchReferenceItem[]} searchData Dataset to use for search
   * @property {boolean} isActive Whether this search modal is in an activated state
   */

  export default {
    name: "the-search-modal",
    components: {
      BaseModal,
      Search,
    },
    /**
     * @returns {TheSearchModalData}
     */
    data() {
      return {
        searchData: [],
        isActive: false,
      }
    },
    methods: {
      /**
       * Fetches meta information about styleguide sections from the data source,
       * transforms it and sets the transformed data in the `data` property.
       * @returns {SearchReferenceItem[]} Transformed data
       */
      async fetchData() {
        const data = await fetchStyleguideData("styleguide.json")
        this.searchData = data.sections.map(transformSearchReferenceItem)
        return this.searchData
      },
      /**
       * Opens this search modal and sets it to an activated state.
       */
      open() {
        this.$refs.modal.open()
        this.isActive = true
      },
      /**
       * Closes this search modal.
       */
      close() {
        this.$refs.modal.close()
      },
      /**
       * Called when modal is closed.
       */
      onModalClose() {
        this.isActive = false
      },
    },
    created() {
      this.fetchData()
    },
  }
